/** Generate a random integer between {@link min} and {@link max}. */
export const randInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);
